import { AfterViewInit, Component, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'ws-site-faq',
  templateUrl: './faq.component.html'
})
export class SiteFaqComponent implements AfterViewInit {
  private links: HTMLAnchorElement[] = [];
  private ticking = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    this.links = Array.prototype.slice.call(this.host.nativeElement.querySelectorAll('.faq-nav a'));
    this.update();
  }

  @HostListener('window:scroll')
  onScroll() {
    if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => this.update()); }
  }

  @HostListener('window:resize')
  onResize() { this.update(); }

  private update() {
    this.ticking = false;
    if (!this.links.length) { return; }
    const root = this.host.nativeElement.getRootNode() as Document | ShadowRoot;
    const targets = this.links.map(a => {
      const id = (a.getAttribute('href') || '').split('#')[1];
      return id ? root.getElementById(id) : null;
    });
    const line = Math.max(window.innerHeight * 0.3, 160);
    let active = 0;
    targets.forEach((el, i) => { if (el && el.getBoundingClientRect().top <= line) { active = i; } });
    this.links.forEach((a, i) => a.classList.toggle('is-active', i === active));
  }
}
